import { useEffect, useState } from "react";

export default function LocationPopup(){
    const [location,setLocation] = useState(null);
    const [error,setError] = useState("");

    useEffect(()=>{
        if("geolocation" in navigator){
            navigator.geolocation.getCurrentPosition((position)=>{
                setLocation({
                    lat:position.coords.latitude,
                    lon:position.coords.longitude,
                });
            },
            (err)=>{
                setError(err.message);
            }
    );
}else{
    setError("Geolocation not supported")
}
    },[location]);
}